<template lang="pug">
  #welcome
    v-card.imageTop( height="100%" width="100%" )
      v-img(:src="require('../assets/img/9648868_orig.png')")
        v-container(fluid style="height:100%")
          v-row.animHeight(justify="center" align="center", style="height:100%")
            v-col(cols='10')
              WelcomeAnim
          v-row(justify="center")
            v-col(cols="12")
    router-view
    //- WelcomeContent(msg='Welcome to City Of Refuge').
</template>

<script>
// @ is an alias to /src
// import WelcomeContent from '@/components/WelcomeContent.vue';
import WelcomeAnim from '../components/WelcomAnim';
export default {
  name: 'welcome',
  components: {
    // WelcomeContent,
    WelcomeAnim
  }
};
</script>
<style lang="stylus">
#welcomeTop
  // background-image url('../../')
  // margin-top -85px
  // border-radius 0
</style>
